import { Pipe, PipeTransform } from '@angular/core';
import { extensionIcons } from './constants';
@Pipe({
  name: 'extensionIcon',
  pure: false,
})
export class ExtensionIconPipe implements PipeTransform {
  transform(fileUrl: string): any {
    const ext = fileUrl?.split('?')[0].split('.').pop();
    return extensionIcons[ext] || extensionIcons['default'];
  }
}

@Pipe({
  name: 'urlFileName',
  pure: false,
})
export class UrlFileNamePipe implements PipeTransform {
  transform(fileUrl: string, args): any {
    let fileName = fileUrl?.split('/').pop();
    args?.noExtension && (fileName = fileName.replace(/\.[^/.]+$/, ''));
    return fileName;
  }
}
